<template>
    <div>
        <draggable v-model="form.data" :group="form.tempId" handle=".handle" @input="emit">
            <tags-data-item
                v-for="(item, index) in form.data"
                :key="item.tempId"
                v-model="form.data[index]"
                v-bind="{
                    type,
                    keys,
                    data: form.data,
                    hideDivider: index == form.data.length - 1,
                }"
                v-on="{
                    pull,
                }"
                @input="emit"
            />
        </draggable>
        <v-divider />
        <v-row no-gutters class="justify-end">
            <v-divider vertical />
            <v-btn icon tile width="40" min-height="40" color="primary" @click="push">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-row>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import { initCommonMetatag_Tag, initCommonMetatag_Tag_Data, COMMON_METATAG_TAG_TYPES } from "@/store/metatags";

import TagsDataItem from "./tags-data-item.vue";

export default {
    components: {
        Draggable,
        TagsDataItem,
    },
    props: {
        value: { type: Object, default: initCommonMetatag_Tag },
    },
    data: () => ({
        form: initCommonMetatag_Tag(),
    }),
    computed: {
        type() {
            return this.value?.type;
        },
        keys() {
            return Object.keys(COMMON_METATAG_TAG_TYPES[this.type]?.data || {});
        },
    },
    methods: {
        sync() {
            this.form = initCommonMetatag_Tag(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        push() {
            this.form.data.push(initCommonMetatag_Tag_Data());
            this.emit();
        },
        pull(item) {
            let index = this.form.data.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.form.data.splice(index, 1);
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
